window.$ = window.jQuery = require('jquery');

require('parsleyjs/src/extra/validator/luhn');
require('parsleyjs');

require('../validations/customValidations.js');
require('../marketingPreferences.js').initialize();
require('../memberRegistration.js').initialize();
require('../payment.js').initialize();
require('../findExisting').initialize();
require('../forms').initialize();
require('../addressPostcodeSearch.js').initialize();
require('../addressSearch.js').initialize();
require('../registerCheckCard.js').initialize();

window.coop = window.coop || {};

require('../../../../src/main/coop-frontend-toolkit/scripts/coop-toolkit.js');
require('../../../../src/main/coop-frontend-toolkit/scripts/modules/coop.Toggles.js');

// eslint-disable-next-line no-undef
Coop.init();


let ParsleyEvents = require('../ParsleyEvents');
new ParsleyEvents().registerValidator();

$('.registration-form').parsley();
$('.existing-member__registration-form').parsley();
$('.member-registration-content__form').parsley();
$('.temporary-card-form').parsley();
$('.existing-member-form').parsley();
$('.register-check-card-form').parsley();

let sessionStorageGuidCookie = require('../sessionStorageGuidCookie.js');
new sessionStorageGuidCookie().assign();
require('../utils/DomUtils');
const AjaxClient = require("../clients/AjaxClient");
new AjaxClient(new XMLHttpRequest());
